import { Card } from '@helix-ds/react'
import { CheckCircle } from 'flowbite-react-icons/outline'

const HEADING = 'text-text-heading dark:text-white font-semibold tracking-tight'
const SUBTLE = 'text-sm font-medium text-text-body-subtle dark:text-gray-500'

/**
 * Terminal screen after discarding a draft in Epic SMART mode. `/orders` is
 * unreachable behind StandaloneAuthGuard, so the provider must relaunch from Epic.
 */
export default function EpicOrderDiscarded() {
  return (
    <main
      className="flex min-h-screen w-full items-center justify-center bg-background-variant-gray dark:bg-gray-950 p-6"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="epic-order-discarded-heading"
      aria-describedby="epic-order-discarded-description"
    >
      <Card className="w-full max-w-md" aria-labelledby="epic-order-discarded-heading">
        <div className="flex flex-col items-center gap-4 text-center">
          <span
            className="flex h-12 w-12 items-center justify-center rounded-full bg-success-100 dark:bg-gray-900"
            aria-hidden="true"
          >
            <CheckCircle className="h-6 w-6 text-success-600" />
          </span>
          <h1 id="epic-order-discarded-heading" className={`${HEADING} text-xl`}>
            Order discarded
          </h1>
          <div id="epic-order-discarded-description" className="flex flex-col gap-3">
            <p className="text-sm font-medium text-text-body dark:text-gray-400">
              The in-progress order has been cleared. Relaunch from Epic to start a new order for this
              patient.
            </p>
            <p className={SUBTLE}>
              Any data entered in the discarded draft is no longer available in this session.
            </p>
          </div>
        </div>
      </Card>
    </main>
  )
}
